import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing }) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: spacing(24),
    width: '100%',
    marginBottom: spacing(16),

    '& .ReferaAttachment__label': {
      width: '100%',
    },
    '& .ReferaAttachment__drop-area': {
      minHeight: spacing(132),
    },
  },
}))
